// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_360O6","titleWrapper":"_13B0C","heading":"_3akRU","subHeading":"_1fhiU"};